import { render, staticRenderFns } from "./TicketDialog.vue?vue&type=template&id=21b06b9f"
import script from "./TicketDialog.vue?vue&type=script&lang=js"
export * from "./TicketDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports